class MindmapSDKSubjectNode {
    constructor(data) {
        this.value = data;        
        this.children = new Array();
    }
}

export default MindmapSDKSubjectNode